export default {
  rss: `${process.env.REACT_APP_RSS_URL}`,
};
